import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";
import { Leaf, Building2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SetupOrganization() {
  const navigate = useNavigate();
  const location = useLocation();
  const [organization, setOrganization] = useState("");
  const [loading, setLoading] = useState(false);
  const user = location.state?.user;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!organization.trim()) {
      toast.error("Veuillez entrer le nom de votre organisation");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API}/auth/update-organization`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ organization: organization.trim() })
      });

      if (!response.ok) {
        throw new Error("Failed to update organization");
      }

      const data = await response.json();
      localStorage.setItem("ecodecide_user", JSON.stringify(data.user));
      
      toast.success("Organisation configurée !");
      navigate("/dashboard");
    } catch (error) {
      toast.error("Erreur lors de la configuration");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md border-0 shadow-lg">
        <CardHeader className="text-center space-y-4">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-primary flex items-center justify-center">
            <Leaf className="w-10 h-10 text-primary-foreground" />
          </div>
          <div>
            <CardTitle className="text-2xl" style={{ fontFamily: 'Manrope' }}>
              Bienvenue {user?.full_name?.split(' ')[0]} !
            </CardTitle>
            <CardDescription className="mt-2">
              Pour terminer votre inscription, veuillez indiquer votre organisation
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="organization">Nom de l'organisation</Label>
              <div className="relative">
                <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  id="organization"
                  type="text"
                  placeholder="Votre entreprise"
                  value={organization}
                  onChange={(e) => setOrganization(e.target.value)}
                  className="pl-10"
                  required
                  data-testid="setup-org-input"
                />
              </div>
            </div>
            <Button 
              type="submit" 
              className="w-full rounded-full" 
              disabled={loading}
              data-testid="setup-org-submit"
            >
              {loading ? "Configuration..." : "Continuer"}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
